<template>
	<div class="wrapper">

		<!-- KLEPTOS -->
		<transition name="zoom"> <!-- appear -->
			<keep-alive>
				<KleptOS
					v-if="showSystem"
					class="theme-95"
					theme="theme-95">
				</KleptOS>
			</keep-alive>
		</transition>

		<!-- CHAPTER SCENE -->
		<div
			class="chapter-scene"
			:class="{ 'active': !showSystem }">

			<!-- GLOBAL MENU -->
			<div class="cover-fill">
				<div class="h-100 container position-relative">
					<ms-menu></ms-menu>
				</div>
			</div>

			<!-- *** ZONE #1 *** -->
			<div class="zone h-100">

				<!-- ZONE BG -->
				<div class="cover-fill">
					<div class="h-100" data-parallax>

						<!-- BRICKS -->
						<div class="bricks" data-depth="0.06">

							<!-- WINDOW -->
							<div class="window" data-parallax>
								<div class="bg bg-skybox" data-depth="-0.1"></div>
								<!-- <video class="bg vids" src="~@/assets/video/walking.mp4" muted autoplay loop></video> -->
								<div class="bg bg-walkers" data-depth="-0.02"></div>
								<div class="bg bg-bushes" data-depth="-0.02"></div>
								<div class="fg"></div>
							</div>

							<!-- POSTER 1 -->
							<div class="poster-1"></div>
						</div>

						<!-- DESK -->
						<div class="desk" data-depth="0.07"></div>

						<!-- ORIGAMI -->
						<div class="origami" data-depth="0.08"></div>

						<!-- CHAIR -->
						<div class="chair" data-depth="0.11"></div>

					</div>
				</div>

				<!-- ZONE FG -->
				<div class="cover-fill">
					<div class="h-100 container position-relative" data-parallax>

						<!-- CEREAL BOWL -->
						<div class="cereal-bowl" data-depth="0.08"></div>

						<!-- TELEPHONE -->
						<div class="telephone is-clickable" data-depth="0.08"></div>

						<!-- LAPTOP -->
						<ms-laptop class="laptop is-clickable" data-depth="0.09">

							 <!-- KLEPTOS -->
							<kleptos
								v-if="!showSystem"
								class="theme-95"
								theme="theme-95">
							</kleptos>

						</ms-laptop>

					</div>
				</div>

			</div>

		</div>

	</div>
</template>

<script>
	import { mapGetters } from 'vuex';
    import KleptOS from '@/components/KleptOS/KleptOS';
    import Menu from '@/components/MenuScreen/Menu/Menu';
    import Laptop from '@/components/MenuScreen/Laptop/Laptop';
    import '@/assets/js/parallax'; // non-moronic custom version

    export default {
        components: {
            KleptOS: KleptOS,
            msMenu: Menu,
            msLaptop: Laptop
        },
        data() {
        	return {
        		parallaxInstances: [],
        		manifest: [
        		    // {
        		    //     id: '1',
        		    //     // src: 'http://www.liquidvisual.net/cyberpunk.mp4'
        		    //     src: 'https://upload.wikimedia.org/wikipedia/commons/2/2c/A_new_map_of_Great_Britain_according_to_the_newest_and_most_exact_observations_%288342715024%29.jpg'
        		    // },
        		    // {
        		    //     id: 'startup',
        		    //     src: require('@/assets/audio/startup.mp3')
        		    // },
        		    // {
        		    //     id: 'music-opener',
        		    //     src: require('@/assets/audio/music-opener.mp3')
        		    // },
        		    {
        		        id: '3',
        		        src: require('@/components/KleptOS/Desktop/assets/img/wallpaper-2.jpg')
        		    },
        		    {
        		        id: '4',
        		        src: require('@/components/KleptOS/Desktop/assets/img/wallpaper-95.jpg')
        		    },
        		    {
        		        id: '5',
        		        src: require('@/components/KleptOS/Desktop/assets/img/wallpaper-os.jpg')
        		    },
        		    // {
        		    //     id: '2',
        		    //     src: 'https://upload.wikimedia.org/wikipedia/commons/thumb/d/d8/02F_Nov_20_2012_2250Z.jpg/2560px-02F_Nov_20_2012_2250Z.jpg'
        		    // },
        		    // {
        		        // id: '3',
        		        // src: 'https://upload.wikimedia.org/wikipedia/commons/thumb/f/fe/01R_Oct_12_2012_0905Z.jpg/2560px-01R_Oct_12_2012_0905Z.jpg'
        		    // }
        		]
        	}
        },
        computed: {
            ...mapGetters('gameOS', [
                'showSystem',
                // 'getTheme'
            ])
        },
        created(){
        	//-----------------------------------------------------------------
        	// EMIT - REQUEST PRELOADER
        	// Each chapter has it's own set of assets to load
        	// this.$store.dispatch('gameOS/setTheme', 0);
        	//-----------------------------------------------------------------

        	// this.$emit('request-preloader', 'MANIFEST - BLAH BLAH BLAH');
        	this.$emit('request-preloader', { manifest: this.manifest });

        	// var url = require('@/assets/media/audio/music-opener.mp3');
        	// createjs.Sound.registerSound(url, 'music-opening');
        	// var instance = createjs.Sound.play('music-opener'); // this works!!
        	    // instance.volume = 0.3;
        },
        mounted(){
        	var parallax = document.querySelectorAll('[data-parallax]');

        	for (var i = 0; i < parallax.length; i++) {
    			this.parallaxInstances[i] = new Parallax(parallax[i],
				{
    		    	limitX: 35,
    		    	limitY: 35,
    			});
        	}
        },
        beforeDestroy(){ // garbage collection
	    	for (var i = 0; i < this.parallaxInstances.length; i++) {
				this.parallaxInstances[i].destroy();
	    	}
	    	this.parallaxInstances = [];
        }
    }
</script>

<style lang="scss" scoped>

	.is-clickable { // make global
		pointer-events: all; // all outer containers have a click-thru
	}

	.zone .container { // GUIDE
		// border: 1px dashed #e6254d;
	}

	//-----------------------------------------------------------------
	// WRAPPER
	//-----------------------------------------------------------------

	.wrapper {
		display: flex;
		flex-direction: column;
		height: 100%;
		// background: #111;
	}

	//-----------------------------------------------------------------
	// CHAPTER SCENE
	//-----------------------------------------------------------------

	.chapter-scene {
		position: relative; // [LOCKED] - safety
		width: 100%; // [LOCKED]
		height: 100%; // [LOCKED]
		max-width: rem-calc(1920);
		max-height: rem-calc(1080);
		overflow: hidden;

		@media (min-width: 1921px) {
			margin-left: auto;
			margin-right: auto;
		}

		@media (min-height: 1080px) {
			margin-top: auto;
			margin-bottom: auto;
		}

		transform: scale(1.02); // [LOCKED]
		transform-origin: center; // [LOCKED]
		transition: transform 0.4s 400ms ease; // [LOCKED]

		@media (max-height: 900px) {
			font-size: rem-calc(13); // previously on wrapper
		}

		&.active {
			transform: scale(1); // [LOCKED]
			transition-delay: 0s; // [LOCKED]
		}
	}

	//-----------------------------------------------------------------
	// COVER FILL (GENERAL)
	//-----------------------------------------------------------------

	.cover-fill {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		pointer-events: none; // parallax instances are none by default
	}

	//-----------------------------------------------------------------
	// OUTER SCENE PROPS
	//-----------------------------------------------------------------

	.bricks {
		position: absolute;
		top: 0;
		left: -10%;
		width: 120%;
		height: 120%;
		// background: black url(~@/assets/img/darkwall.jpg) repeat top center;
		// background: url(~@/assets/img/basement-9@2x.jpg) no-repeat top;
		background: url(~@/assets/img/basement-10@2x.jpg) no-repeat top;
		// background: aqua url(~@/assets/img/basement-2@2x.jpg) no-repeat top;
		// background: black url(~@/assets/img/doobie2.png) no-repeat center top;
		// background-size: cover; // [LOCKED] - no black bars
		// background-size: 1650px;
		// background-size: rem-calc(2500);
		// background-size: rem-calc(2460);
		background-size: rem-calc(2000);
		// background-size: rem-calc(3060);
		// background-size: rem-calc(1360);
	}

	//-----------------------------------------------------------------
	// WINDOW
	//-----------------------------------------------------------------

	.window {
		position: absolute;
		top: 30px; //20px; ////-70
		left: 10%; // 20%
		width: em-calc(1360/2.3); //520px
		height: em-calc(424/2.3);
		overflow: hidden;

		background-image: url(~@/assets/img/window-sky@2x.png);
	}

	.window .bg,
	.window .fg {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-size: 100%;
		background-repeat: no-repeat;
	}

	.window .bg {
		background-image: url(~@/assets/img/window-bg-6@2x.png);
		top: 2px;
		height: calc(100% - 4px);
	}

	.window .fg {
		background-image: url(~@/assets/img/window-4-cobbies@2x.png);
		z-index: 2;
	}

	.window .bg-skybox {
		background-image: url(~@/assets/img/window-sky-lighter@2x.png);
		top: 2px;
		height: calc(100% - 4px);
	}

	.window .bg-walkers {
		background-image: url(~@/assets/video/walking-test.gif);
		top: 2px;
		height: calc(100% - 4px);
		background-size: 170%;
		background-position: bottom;
	}

	//-----------------------------------------------------------------
	// POSTERS
	//-----------------------------------------------------------------

	.poster-1 {
		position: absolute;
		top: -50px;
		left: 50%;
		width: em-calc(682px / 2.4);
		height: em-calc(1023px / 2.4);
		filter: brightness(20%);
		box-shadow: 0 2px 2px 1px rgba(black, 0.5);
		transform: rotate(-3deg);
		background: url(~@/assets/img/hackers-poster.jpg) no-repeat;
		background-size: contain;
	}

	//-----------------------------------------------------------------
	// INNER SCENE PROPS (CONTAINER)
	//-----------------------------------------------------------------

	.desk {
		position: absolute;
		left: calc(50% - #{em-calc(3120/2)});
		// bottom: em-calc(-42);
		bottom: 0;
		width: em-calc(3120);
		height: em-calc(400); // [LOCKED]
		background: url(~@/assets/img/desk-15@2x.png) no-repeat bottom center;
		// background: url(~@/assets/img/desk-no-shadow@2x.png) no-repeat bottom center;
		background-size: em-calc(3120);
	}

	.chair {
		position: absolute;
		right: em-calc(-60); // -60
		bottom: em-calc(-20); // -20
		width: em-calc(420); // 414
		height: em-calc(135); // 115
		background: url(~@/assets/img/chair-back-4@2x.png) no-repeat;
		background-size: contain;
		z-index: 1;
	}

	.cereal-bowl {
		position: absolute;
		left: 1%; // 59%
		bottom: em-calc(210); // 145
		width: em-calc(987/3.96); // 340
		height: em-calc(684/3.96); // 800
		background: url(~@/assets/img/bowl-1@2x.png) no-repeat bottom center;
		background-size: contain;
	}

	.laptop { // is component
		position: absolute;
		left: 22%;
		// bottom: em-calc(-20);
		bottom: rem-calc(115);
		width: em-calc(1756/3.4); // /3.2
		height: em-calc(1800/3.4-130);
		// border: 1px solid red;
	}

	.telephone {
		position: absolute;
		left: 57.5%; // 59%
		bottom: em-calc(165); // 145
		width: em-calc(312); // 340
		height: em-calc(770); // 800
		background: url(~@/assets/img/phone-with-shine-2.png) no-repeat bottom center;
		background-size: contain;
	}

	.origami {
		position: absolute;
		// left: 78%; // 59%
		left: calc(57.5% + #{rem-calc(320)}); // 59%
		bottom: em-calc(90); // 145
		width: em-calc(140); // 340
		height: em-calc(770); // 800
		background: url(~@/assets/img/origami@2x.png) no-repeat bottom center;
		background-size: 100%;
		// z-index: 1;
	}

	//-----------------------------------------------------------------
	// TRANSITION
	//-----------------------------------------------------------------

	.zoom-enter-active {
		transition: all 300ms ease;
	}

	// .zoom-leave-active {
	// 	transition: all 200ms ease 100ms;
	// }

	.zoom-enter {
		transform: scale(0.9);
		opacity: 0;
	}

	// .zoom-leave-to {
	// 	transform: scale(0.95);
	// 	transform: translateY(50px) scale(0.9);
	// 	opacity: 0;
	// }

	//-----------------------------------------------------------------
	// FILM GRAIN
	//-----------------------------------------------------------------

	.chapter-scene:after {
		// content: "";
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: url(~@/assets/img/grain@2x.png);
		background-size: 100px;
		animation: grain-filter 0.25s steps(2) infinite;
		opacity: 0.4;
		pointer-events: none;
	}

	@keyframes grain-filter {
	    0% { transform: rotate(0deg); }
	    100% { transform: rotate(-360deg); }
	}
</style>